import { motion } from "motion/react";
import banner from "../../assets/images/hereobanner.jpg";
import banner_mobile from "../../assets/images/mobile_size_2.jpg";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import PlaceIcon from "@mui/icons-material/Place";
import { Link } from "react-router-dom";
import { useModal } from "../ModalContext";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
const HeroBanner = () => {
  const { openModal } = useModal();
  const bottomList = [
    "No GST",
    "HMDA Approved",
    "RERA Registered",
    "OC Received",
  ];
  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden flex flex-col justify-between">
      <div className="absolute inset-0 w-full h-full hidden lg:block">
        <img
          src={banner}
          className="w-full h-full object-cover object-center"
          alt="2 BHK flats in Patancheru"
        />
      </div>
      <div className="absolute inset-0 w-full h-full block lg:hidden">
        <img
          src={banner_mobile}
          className="w-full h-full object-cover object-center"
          alt="2 BHK flats in Patancheru"
        />
      </div>
      <div className="absolute inset-0 bg-black/30 pointer-events-none" />
      <div className="relative z-10 flex-1 flex items-center pt-28 pb-12 sm:pt-32 md:pt-40 lg:pt-48">
        <div className="w-full px-5 sm:px-8 md:px-12 lg:px-20 xl:px-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full max-w-[650px] lg:max-w-[750px] text-left"
          >
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.7 }}
              className="mb-4 sm:mb-6 inline-block border border-[#d5c5b5]/70 px-4 py-2 sm:px-2 sm:py-3 md:px-8 md:py-4 backdrop-blur-xs"
            >
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center font-crimson font-bold tracking-wide text-[#e7d8ca]">
                Ready to move 2BHK{" "}
                <br/>              
              <span className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-crimson  text-center font-semibold tracking-wide text-[#e7d8ca] mt-0.5">
                Flats in a Gated Community
              </span></h1>
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3, duration: 0.7 }}
              className="mb-3 sm:mb-4 lg:mb-6 mt-4 font-crimson flex flex-wrap items-baseline gap-2"
            >
              <span className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium text-[#d86a13]">
                2 BHK Flats starting from 

              </span>
              <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#d86a13]">
                ₹55 Lakhs Onwards
              </span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="mb-5 sm:mb-6 text-base sm:text-xl md:text-2xl lg:text-3xl font-crimson italic leading-snug text-[#d5c5b5]"
            >
              It's a Revolution in Affordable Living
            </motion.p>
            <div className="mt-4 lg:pt-16">
              <button
                className="group relative inline-flex items-center gap-3 sm:gap-4 px-5 py-2.5 sm:px-6 sm:py-3 md:px-7 md:py-3.5 bg-[#c55b12] text-white text-xs sm:text-sm md:text-base lg:text-lg uppercase rounded-xl sm:rounded-2xl transition-all duration-300 font-Poppins font-medium overflow-hidden shadow-[0_6px_12px_rgba(197,91,18,0.45)] hover:shadow-[0_8px_16px_rgba(197,91,18,0.6)] active:scale-95"
                onClick={openModal}
              >
                <span className="whitespace-nowrap">
                  Book Your Site Visit Today
                </span>
                <span className="relative grid place-items-center w-3.5 h-3.5 sm:w-4 sm:h-4">
                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute w-full h-full transition-transform duration-300 ease-in-out group-hover:translate-x-[150%] group-hover:-translate-y-[250%]"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    />
                  </svg>
                  <svg
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute w-full h-full transition-transform duration-300 ease-in-out translate-x-[-150%] translate-y-[250%] delay-100 group-hover:translate-x-0 group-hover:translate-y-0"
                  >
                    <path
                      d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </button>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.7 }}
              className="mt-6 sm:mt-8 space-y-2 sm:space-y-3"
            >
              <div>
                <Link
                  className="font-inter inline-flex items-center gap-2.5 sm:gap-3 group"
                  to="tel:+919091999916"
                >
                  <PhoneInTalkIcon
                    sx={{ color: "#d86a13" }}
                    className="!text-xl sm:!text-2xl md:!text-3xl shrink-0"
                  />
                  <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white relative transition-colors duration-300">
                    +91 90919 99916
                    <span className="absolute bottom-0 left-1/2 w-0 h-[1.5px] bg-white transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0" />
                  </p>
                </Link>
              </div>
              <div>
                <Link
                  className="font-Poppins inline-flex items-center gap-2.5 sm:gap-3 group"
                  to="https://maps.app.goo.gl/5fwH6As6zN34WXZa6"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <PlaceIcon
                    sx={{ color: "#d86a13" }}
                    className="!text-xl sm:!text-2xl md:!text-3xl shrink-0"
                  />
                  <p className="text-sm sm:text-base md:text-lg lg:text-xl relative text-white transition-colors duration-300">
                    Nandigaon, Patancheru
                    <span className="absolute bottom-0 left-1/2 w-0 h-[1.5px] bg-white transition-all duration-300 ease-in-out group-hover:w-full group-hover:left-0" />
                  </p>
                </Link>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
      <div className="relative z-10 w-full px-5 sm:px-8 md:px-12 lg:px-20 xl:px-24 pb-6 pt-4">
        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:gap-6 lg:grid-cols-4 items-center">
          {bottomList.map((item, index) => (
            <div
              className="flex items-center md:justify-center gap-2 sm:gap-2.5"
              key={index}
            >
              <CheckBoxOutlinedIcon
                sx={{ color: "#d86a13" }}
                className="!text-lg sm:!text-xl md:!text-2xl shrink-0"
              />
              <h3 className="text-xs sm:text-sm md:text-base lg:text-lg font-bold text-white tracking-wide truncate">
                {item}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;